export default __webpack_public_path__ + "static/roadmap_bg_right-9f72bde31b765389552a4bc6364a9fde.png";